import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from 'src/core/components/dashboard/dashboard.component';
import { PortalComponent } from 'src/core/components/portal/portal.component';
import { ClientFormComponent } from 'src/form/components/client-form/client-form.component';
import { PrescriptionListComponent } from 'src/core/components/prescription-list/prescription-list.component';
import { PrescriptionReviewComponent } from '../core/components/prescription-review/prescription-review.component';
import { PrescriptionFormComponent } from 'src/core/components/prescription-form/prescription-form.component';
import { PrescriptionViewComponent } from 'src/core/components/prescription-view/prescription-view.component';
import { OrderListComponent } from '../core/components/order-list/order-list.component';

import { ShippingFormComponent } from '../core/components/shipping-form/shipping-form.component';
import { BatchListComponent } from 'src/core/components/batch-list/batch-list.component';
import { BatchCreateComponent } from 'src/core/components/batch-create/batch-create.component';
import { BatchViewComponent } from 'src/core/components/batch-view/batch-view.component';
import { OrderResolver, OrdersResolver } from 'src/resolvers/order';
import { BatchResolver, BatchesResolver } from 'src/resolvers/batch';
import { OrderSplitComponent } from 'src/core/components/order-split/order-split.component';
import { UserCreateComponent } from 'src/core/components/user-create/user-create.component';
import { UserListComponent } from 'src/core/components/user-list/user-list.component';
import { UserViewComponent } from 'src/core/components/user-view/user-view.component';
import { UserResolver, UsersResolver } from 'src/resolvers/user';
import {
  IndividualResolver,
  IndividualsResolver,
} from 'src/resolvers/individual';
import { IndividualViewComponent } from 'src/core/components/individual-view/individual-view.component';
import { IndividualListComponent } from 'src/core/components/individual-list/individual-list.component';
import { IndividualCreateComponent } from 'src/core/components/individual-create/individual-create.component';
import { MedicineCreateComponent } from 'src/core/components/medicine-create/medicine-create.component';
import { OrderMedicineCreateComponent } from 'src/core/components/order-medicine-create/order-medicine-create.component';
import { OrderMedicineListComponent } from 'src/core/components/order-medicine-list/order-medicine-list.component';
import { MedicineListComponent } from 'src/core/components/medicine-list/medicine-list.component';
import { MedicineViewComponent } from 'src/core/components/medicine-view/medicine-view.component';
import { MedicineListResolver, MedicineResolver } from 'src/resolvers/medicine';
import { DirtinessGuard } from 'src/core/guards/dirtiness.guard';
import { LogListComponent } from 'src/core/components/log-list/log-list.component';
import { LogsResolver } from 'src/resolvers/log';
import { DashboardResolver } from 'src/resolvers/dashboard';
import { CompanyCreateComponent } from 'src/core/components/company-create/company-create.component';
import { CompanyListComponent } from 'src/core/components/company-list/company-list.component';
import { CompanyViewComponent } from 'src/core/components/company-view/company-view.component';
import { CompanyListResolver, CompanyResolver } from 'src/resolvers/company';
import { NotFoundErrorComponent } from 'src/core/components/not-found-error/not-found-error.component';
import { TermsAndConditionsComponent } from 'src/core/components/terms-and-conditions/terms-and-conditions.component';
import { OrderFulfilmentComponent } from 'src/core/components/order-fulfilment/order-fulfilment.component';
import { StocktakeViewComponent } from 'src/core/components/stocktake-view/stocktake-view.component';
import { FulfilmentGuard } from 'src/core/guards/fulfilment.guard';
import { RoleAuthorisationGuard } from 'src/core/guards/role-authorisation.guard';
import { StocktakeReportsComponent } from 'src/core/components/stocktake-reports/stocktake-reports.component';
import { StocktakeLocationLiveComponent } from 'src/core/components/stocktake-location-live/stocktake-location-live.component';
import { WaybillReviewOrdersComponent } from 'src/core/components/waybill-review-orders/waybill-review-orders.component';

const routes: Routes = [
  { path: '', redirectTo: '/portal', pathMatch: 'full' },
  { path: 'tandcs', component: TermsAndConditionsComponent },
  { path: 'waybill/review/:waybill', component: WaybillReviewOrdersComponent },
  {
    path: 'portal',
    component: PortalComponent,
    canActivate: [RoleAuthorisationGuard],
    //canActivateChild: [RoleAuthorisationGuard],
    children: [
      {
        path: 'dashboard',
        runGuardsAndResolvers: 'always',
        component: DashboardComponent,
        resolve: {
          dashboardData: DashboardResolver,
        },
      },
      {
        path: 'stocktake',
        // runGuardsAndResolvers: 'always',
        component: StocktakeViewComponent,
        // resolve: {
        //   dashboardData: DashboardResolver
        // }
      },
      {
        path: 'stocktake/report',
        // runGuardsAndResolvers: 'always',
        component: StocktakeReportsComponent,
        // resolve: {
        //   dashboardData: DashboardResolver
        // }
      },
      {
        path: 'stocktake/location',
        component: StocktakeLocationLiveComponent,
      },
      {
        path: 'submit',
        component: ClientFormComponent,
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'prescriptions',
        component: PrescriptionListComponent,
        pathMatch: 'full',
        resolve: {
          orders: OrdersResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'prescriptions-form',
        component: PrescriptionFormComponent,
        pathMatch: 'full',
        resolve: {
          orders: OrdersResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'prescriptions/review/:id',
        component: PrescriptionReviewComponent,
        resolve: {
          order: OrderResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'prescriptions/view/:id',
        component: PrescriptionViewComponent,
        resolve: {
          order: OrderResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'split/:id',
        component: OrderSplitComponent,
        resolve: {
          order: OrderResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'fulfill/:id',
        component: OrderFulfilmentComponent,
        resolve: {
          order: OrderResolver,
        },
        canDeactivate: [FulfilmentGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'shipping',
        pathMatch: 'full',
        component: OrderListComponent,
        resolve: {
          orders: OrdersResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'shipping/details/:id',
        component: ShippingFormComponent,
        resolve: {
          order: OrderResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },

      {
        path: 'batches',
        pathMatch: 'full',
        component: BatchListComponent,
        resolve: {
          batches: BatchesResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'batches/create',
        component: BatchCreateComponent,
        //  canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'batches/view/:id',
        component: BatchViewComponent,
        resolve: {
          batch: BatchResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'users/create',
        component: UserCreateComponent,
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'users',
        pathMatch: 'full',
        component: UserListComponent,
        resolve: {
          users: UsersResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'users/view/:name',
        component: UserViewComponent,
        resolve: {
          user: UserResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'individuals/create',
        component: IndividualCreateComponent,
        // canActivate: [RoleAuthorisationGuard],
      },
      {
        path: 'individuals',
        pathMatch: 'full',
        component: IndividualListComponent,
        resolve: {
          individuals: IndividualsResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'individuals/view/:id',
        pathMatch: 'full',
        component: IndividualViewComponent,
        resolve: {
          individual: IndividualResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'companies/create',
        component: CompanyCreateComponent,
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'companies',
        pathMatch: 'full',
        component: CompanyListComponent,
        resolve: {
          companies: CompanyListResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'companies/view/:id',
        pathMatch: 'full',
        component: CompanyViewComponent,
        resolve: {
          company: CompanyResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'medicine/create',
        component: MedicineCreateComponent,
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'medicine',
        pathMatch: 'full',
        component: MedicineListComponent,
        resolve: {
          medicine: MedicineListResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'medicine/view/:id',
        component: MedicineViewComponent,
        resolve: {
          medicine: MedicineResolver,
        },
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'order-medicine/create',
        component: OrderMedicineCreateComponent,
        canDeactivate: [DirtinessGuard],
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'order-medicine',
        component: OrderMedicineListComponent,
        // canActivate: [RoleAuthorisationGuard]
      },



      {
        path: 'logs',
        pathMatch: 'full',
        component: LogListComponent,
        resolve: {
          logs: LogsResolver,
        },
        // canActivate: [RoleAuthorisationGuard]
      },
      {
        path: 'integrations',
        canActivate: [RoleAuthorisationGuard],
        loadChildren: () =>
          import('./integrations/integrations.module').then(
            (m) => m.IntegrationsModule
          ),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    BatchResolver,
    BatchesResolver,
    OrderResolver,
    OrdersResolver,
    UserResolver,
    UsersResolver,
    IndividualsResolver,
    IndividualResolver,
    MedicineListResolver,
    MedicineResolver,
    DirtinessGuard,
    LogsResolver,
    DashboardResolver,
    CompanyResolver,
    CompanyListResolver,
    FulfilmentGuard,
    RoleAuthorisationGuard,
  ],
})
export class AppRoutingModule {}
